// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-page[data-v-31324cce]{background:hsla(0,0%,100%,.8);font-family:sans-serif;font-size:30px;height:100%;left:0;position:fixed;text-align:center;top:0;width:100%}.loading[data-v-31324cce]{animation:spin-31324cce 1s ease-in-out infinite;border:4px solid #061450;border-radius:50%;border-top-color:#fff;display:inline-block;height:1.5rem;margin:0;position:absolute;top:50%;width:1.5rem}@keyframes spin-31324cce{to{-webkit-transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
